import { PDFViewer } from "@react-pdf/renderer";
import { CVDocument } from "../components/cv/CVDocument";
import { Box, CircularProgress } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import CVData from "../types/CVData";
import { getCVById } from "../services/cvService";

const PDFViewerComponent = () => {
  const token = localStorage.getItem("token");
  const location = useLocation();
  const userIdFromPreview = location.state?.userId;
  const formDataFromState = location.state?.formData as CVData | undefined;

  const [userData, setUserData] = useState<CVData | null>(
    formDataFromState ?? null
  );

  useEffect(() => {
    // Use passed form data (unsaved changes from CreateCV) when available
    if (formDataFromState) {
      setUserData(formDataFromState);
      return;
    }

    const cvId = userIdFromPreview ?? (token ? token.split("_")[2] : null);
    if (!cvId) return;

    let cancelled = false;
    getCVById(cvId)
      .then((data) => {
        if (!cancelled) setUserData(data);
      })
      .catch(() => {
        if (!cancelled) setUserData(null);
      });
    return () => {
      cancelled = true;
    };
  }, [userIdFromPreview, token, formDataFromState]);

  return (
    <Box
      sx={{
        width: "100vw",
        height: "calc(100vh - 100px)",
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {userData ? (
        <PDFViewer height="100%" width="100%" style={{ border: "none" }}>
          <CVDocument formData={userData} includeName />
        </PDFViewer>
      ) : (
        <CircularProgress />
      )}
    </Box>
  );
};
export default PDFViewerComponent;
